export default __webpack_public_path__ + "static/media/mobile_logo.dcb5226b.svg";